import React from "react";

export const ConversationSkeleton: React.FC = () => {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: "768px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        padding: "16px",
      }}
    >
      {/* Skeleton for user message - matches actual user message styling */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          animation: "fadeIn 0.3s ease-in",
        }}
      >
        <div
          style={{
            width: "min(70%, 280px)",
            height: "48px",
            backgroundColor: "#EEF4FC",
            borderRadius: "18px",
            borderBottomRightRadius: "5px",
            animation: "pulse 1.5s ease-in-out infinite",
          }}
        />
      </div>

      {/* Skeleton for assistant message - full width like actual messages */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          animation: "fadeIn 0.3s ease-in 0.2s both",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          {/* Text content skeleton */}
          <div
            style={{
              width: "100%",
              height: "80px",
              backgroundColor: "#f8f9fa",
              borderRadius: "12px",
              animation: "pulse 1.5s ease-in-out infinite",
            }}
          />
          {/* Second text block skeleton */}
          <div
            style={{
              width: "85%",
              height: "60px",
              backgroundColor: "#f8f9fa",
              borderRadius: "12px",
              animation: "pulse 1.5s ease-in-out infinite",
              animationDelay: "0.2s",
            }}
          />
        </div>
      </div>

      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
        `}
      </style>
    </div>
  );
};
